import { connect } from 'react-redux';
import { updateRoleSelectionForm, stepValidationStatusChanged } from '../actions';
import RolePageStep from '../components/RolePageStep';
import { getRolePageStep } from '../selectors';

const mapStateToProps = state => getRolePageStep(state);

const mapDispatchToProps = dispatch => ({
    onRoleSelection: role => dispatch(updateRoleSelectionForm(role)),
    onStepValidationStatusChanged: stepValidationStatus => dispatch(stepValidationStatusChanged(stepValidationStatus)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RolePageStep);
